import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, } from '@tribeplatform/react-ui-kit/FormControl';
export function Textarea({ name, validation, value: fieldValue, onChange: selectOnChange, defaultValue, ...rest }) {
    var _a, _b;
    const { control } = useFormContext();
    const maxLength = typeof (validation === null || validation === void 0 ? void 0 : validation.maxLength) === 'object' &&
        typeof ((_a = validation === null || validation === void 0 ? void 0 : validation.maxLength) === null || _a === void 0 ? void 0 : _a.value) === 'number'
        ? (_b = validation === null || validation === void 0 ? void 0 : validation.maxLength) === null || _b === void 0 ? void 0 : _b.value
        : undefined;
    return (_jsx(Controller, { control: control, name: name, rules: validation, defaultValue: defaultValue, render: ({ field: { onChange, value }, fieldState: { error } }) => (_jsx(FormControl.Textarea, { ...rest, name: name, invalid: !!(error === null || error === void 0 ? void 0 : error.message), error: error === null || error === void 0 ? void 0 : error.message, onChange: value => {
                onChange(value);
                if (typeof selectOnChange === 'function')
                    selectOnChange(value);
            }, value: fieldValue !== null && fieldValue !== void 0 ? fieldValue : value, cornerHint: maxLength > 0 && !!value
                ? `${value.length}/${maxLength}`
                : undefined }, void 0)) }, void 0));
}
//# sourceMappingURL=Textarea.js.map